import React from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Bar } from 'react-chartjs-2'
import colorChats from '../../lib/colorChats'

const options = {
  responsive: true,
  legend: {
    display: false,
    position: 'top'
  },
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: 'Chart.js Bar Chart',
    },
  },
};

var totalGrafico = 0;

const BarrasHora = ({ title, color, dados }) => {
  var data='';

  if (typeof dados.horas != "undefined") {
    let dtset         = [];

    totalGrafico = 0;

    dados.valores.forEach(valor=>{
      totalGrafico = totalGrafico + Number(valor);
    })

    dtset.push({        
              // label: dados.horas,
              data: dados.valores,
              backgroundColor: colorChats.vivida
          })

    const labels = dados.horas;
    data = {
      labels,
      datasets: dtset
    };
  
  } else {
      return (<></>)
  }




  return (
    <Card className='mb-0 mt-4'>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor">
              {"Total: " + totalGrafico}
            </div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Bar
          data={data}
          options={options}
          width={550}
          height={150}
        />
      </CardBody>
    </Card>
  )
}

export default BarrasHora








